
import { Vue, Options } from 'vue-class-component'
import { dashboardDataFactory } from '@/http/dashboard-data'
import constants from '@/constants/constants'

@Options({
  props: {
    param: Object
  },
  name: 'RecentPayment',
  watch: {
    param: {
      handler: 'resetloadDatas',
      deep: true
    }
  },
  data () {
    return {
      invoices: [],
      offset: 0,
      enableScroll: true
    }
  },
  methods: {
    loadDatas: async function () {
      Promise.all([
        dashboardDataFactory.recentPayment(this.param, 10, this.offset)
      ]).then((response) => {
        const data = response[0].data

        if (data.length == 0 && this.offset > 0) {
          this.enableScroll = false
          // make footer to show no more data
          document.getElementById('footer-recent-payment').style.display = 'block'
          setTimeout(() => {
            document.getElementById('footer-recent-payment').style.display = 'none'
          }, 3000)
        }

        // looping data
        for (let i = 0; i < data.length; i++) {
          const temp = {
            invoice_id: data[i].id,
            invoice_number: data[i].invoice_no,
            status: (data[i].status == constants.ORDER_SUCCESS || data[i].status == constants.ORDER_SUCCESS_MANUAL) ? 'Lunas' : 'Belum Lunas',
            type: data[i].details[0].installment.bill_user.bill.type.name || '',
            total_payment: data[i].total_payment,
            user_status: data[i].student.status || ''
          }
          this.invoices.push(temp)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    scroll: function (e) {
      if (e.target.scrollTop + e.target.clientHeight + 1 >= e.target.scrollHeight && this.enableScroll) {
        this.offset += 10
        this.loadDatas()
      }
    },
    resetloadDatas: function () {
      this.invoices = []
      this.offset = 0
      this.enableScroll = true
      this.loadDatas()
    }
  },
  mounted () {
    this.loadDatas()
  }
})
export default class RecentPayment extends Vue { }
